import React from "react";
import { NavLink } from "react-router-dom";

interface AdministrationTab{
  path: string;
  label: string;
}

const administrationTabs: AdministrationTab[] = [
  {
    path: "users",
    label: "Users",
  },
  {
    path: "pgi-mappings",
    label: "PGI",
  },
  // {
  //   path: "user-roles",
  //   label: "User Roles",
  // },
];

export const AdministrationTabs: React.FC = () => {

  return (
    <div className="d-flex align-items-center px-4 bg-teal-light">
      <ul className="tabs flex-fill">
        {administrationTabs.map((tab, idx) => (
          <li className="tabs__item" key={idx}>
            <NavLink
              className={`tabs__link `}
              to={tab.path}
            >
              {tab.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </div>
  );
};
